import React, {useEffect, useState, useRef} from "react";
import {Col, Container, Row} from 'reactstrap';
import IMGIA from '../assets/images/ia_plantao_rapido.png';
import AOS from "aos";
import "aos/dist/aos.css";
import Lottie from "lottie-react";
import typingAnimation from "../assets/animations/robot-typing.json";
import ApiService from "../admin/components/util/ApiService"; // Vamos baixar um lottie de typing robot
const Footer = () => {
    const domain = window.location.hostname;

    const [footerData, setFooterData] = useState(() => {
        try {
            const cachedData = localStorage.getItem(`custom_images_${domain}`);
            const cachedImages = cachedData ? JSON.parse(cachedData) : {};
            return {
                title: cachedImages.titleFooter || 'MEDR',
                url: cachedImages.companyUrlFooter || 'https://medr.com.br/',
            };
        } catch {
            return { title: 'MEDR', url: 'https://medr.com.br/' };
        }
    });

    const [showChat, setShowChat] = useState(false);
    const [userMessage, setUserMessage] = useState('');
    const [chatHistory, setChatHistory] = useState([
        {author: 'ai', text: 'Olá! 👋 Como posso te ajudar hoje?'}
    ]);
    const chatRef = useRef(null);
    const [isTyping, setIsTyping] = useState(false);

    useEffect(() => {
        const updateFooterData = () => {
            try {
                const cachedData = localStorage.getItem(`custom_images_${domain}`);
                const cachedImages = cachedData ? JSON.parse(cachedData) : {};
                if (cachedImages.titleFooter || cachedImages.companyUrlFooter) {
                    setFooterData({
                        title: cachedImages.titleFooter || 'MEDR',
                        url: cachedImages.companyUrlFooter || 'https://medr.com.br/',
                    });
                }
            } catch (error) {
                console.error('Erro ao carregar dados do footer:', error);
            }
        };

        const interval = setInterval(updateFooterData, 500);
        const timeout = setTimeout(() => clearInterval(interval), 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [domain]);

    const toggleChat = () => {
        setShowChat(!showChat);
    };

    useEffect(() => {
        AOS.init({
            duration: 1200,
            once: true,
        });
    }, []);

    const sendMessage = async () => {
        if (!userMessage.trim()) return;

        setChatHistory(prev => [
            ...prev,
            {author: 'user', text: userMessage}
        ]);

        const currentMessage = userMessage;
        setUserMessage('');
        setIsTyping(true); // << Ativa o "digitando" animado

        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}ia/chat`,
                {message: currentMessage},
                false
            );

            console.log(response);
            const aiReply = response.data.outputText || 'Desculpe, não consegui responder agora.';

            setChatHistory(prev => [
                ...prev,
                {author: 'ai', text: aiReply}
            ]);
        } catch (error) {
            console.error(error);

            setChatHistory(prev => [
                ...prev,
                {author: 'ai', text: 'Erro ao obter resposta. Tente novamente.'}
            ]);
        } finally {
            setIsTyping(false); // << Desativa "digitando"
        }
    };


    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [chatHistory]);

    return (<>


            <button
                onClick={toggleChat}
                className="chat-button-hover"
                style={{
                    position: 'fixed',
                    bottom: '100px',
                    right: '10px',
                    backgroundColor: '#ffffff',
                    border: 'none',
                    borderRadius: '50%',
                    width: '55px',
                    height: '55px',
                    padding: 0,
                    cursor: 'pointer',
                    zIndex: 1000,
                    transition: 'transform 0.2s ease-in-out',
                }}
            >
                <img
                    src={IMGIA}
                    alt="IA Plantão Rápido"
                    style={{
                        marginTop: '0px',
                        width: '55px',
                        height: '55px',
                        borderRadius: '50%',
                        boxShadow: `
                            0 0 0 3px rgba(173, 216, 255, 0.8),   /* azul mais claro */
                            0 0 10px rgba(173, 216, 255, 0.4),
                            0 0 20px rgba(173, 216, 255, 0.3)
                          `,
                        transition: 'box-shadow 0.3s ease-in-out',
                    }}
                />
            </button>


            {showChat && (
                <div style={{
                    position: 'fixed',
                    bottom: '100px',
                    right: '20px',
                    width: '320px',
                    height: '450px',
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                    zIndex: 1000,
                }}>
                    {/* Header */}
                    <div style={{
                        position: 'relative',
                        padding: '15px',
                        background: '#2189c8',
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        textAlign: 'center',
                    }}>
                        IA Plantão Rápido
                        {/* Botão de fechar */}
                        <span
                            onClick={toggleChat}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                width: '24px',
                                height: '24px',
                                cursor: 'pointer',
                                zIndex: 1001,
                            }}
                        >
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="white"
                                  width="24px"
                                  height="24px"
                              >
                                <path
                                    d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7a1 1 0 10-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z"/>
                              </svg>
                            </span>
                    </div>

                    {/* Chat Body */}
                    <div
                        ref={chatRef}
                        style={{
                            flex: 1,
                            overflowY: 'auto',
                            padding: '10px',
                            backgroundColor: '#f7f9fc',
                        }}
                    >
                        {chatHistory.map((item, index) => (
                            <div key={index} style={{
                                textAlign: item.author === 'user' ? 'right' : 'left',
                                marginBottom: '10px',
                                display: 'flex',
                                justifyContent: item.author === 'user' ? 'flex-end' : 'flex-start',
                            }}>
          <span style={{
              display: 'inline-block',
              padding: '10px 14px',
              backgroundColor: item.author === 'user' ? '#2189c8' : '#e1f3fb',
              color: item.author === 'user' ? '#ffffff' : '#333',
              borderRadius: '20px',
              maxWidth: '80%',
              wordBreak: 'break-word',
              fontSize: '14px',
          }}>
            {item.text}
          </span>
                            </div>
                        ))}

                        {isTyping && (
                            <div style={{
                                textAlign: 'left',
                                marginBottom: '10px',
                                display: 'flex',
                                justifyContent: 'flex-start',
                            }}>
                                <div style={{
                                    backgroundColor: '#e1f3fb',
                                    borderRadius: '20px',
                                    padding: '6px 10px',
                                    maxWidth: '60%',
                                }}>
                                    <Lottie
                                        animationData={typingAnimation}
                                        loop
                                        style={{width: 40, height: 40}}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Chat Input */}
                    <div style={{
                        display: 'flex',
                        borderTop: '1px solid #e1e1e1',
                        padding: '10px',
                        backgroundColor: '#ffffff',
                    }}>
                        <input
                            type="text"
                            value={userMessage}
                            onChange={(e) => setUserMessage(e.target.value)}
                            placeholder="Digite sua mensagem..."
                            style={{
                                flex: 1,
                                padding: '10px',
                                borderRadius: '25px',
                                border: '1px solid #ddd',
                                outline: 'none',
                                fontSize: '14px',
                                marginRight: '10px',
                            }}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') sendMessage();
                            }}
                        />
                        <button
                            onClick={sendMessage}
                            style={{
                                width: '45px',
                                height: '45px',
                                backgroundColor: '#2189c8',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontSize: '18px',
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white"
                                 viewBox="0 0 24 24">
                                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            )}


            <React.Fragment>
                <footer className="footer">
                    <Container fluid>
                        <Row>
                            <Col sm={6}>
                                {new Date().getFullYear()} © <a className="text-reset text-decoration-none"
                                                                target="_blank" rel="noopener noreferrer" href={footerData.url}>{footerData.title}</a>.
                            </Col>
                            <Col sm={6}>
                                <div className="text-sm-end d-none d-sm-block">
                                    Todos os Direitos Reservados
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </React.Fragment>
        </>
    );
};

export default Footer;